import { Typography as MuiTypography } from "@material-ui/core";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import { z } from "zod";

import useQueryParams from "../../hooks/useQueryParams";
import FiltersForm from "../../components/FiltersForm";
import NutrientRatioChartContainer from "../../components/charts/nutrientRatioChart/NutrientRatioChartContainer";
import { getWaterYearRange } from "../fieldDepthProfile/FieldDepthProfile";
import React from "react";
import { usePostHeight } from "../../hooks/usePostHeight";

const Section = styled.section`
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
`;
const Typography = styled(MuiTypography)(spacing);

const { start_date, end_date } = getWaterYearRange();

const LOCATION_OPTIONS = [
  { label: "CCR1 – Cherry Creek Res. Station 1", value: "79" },
  { label: "CCR2 – Cherry Creek Res. Station 2", value: "80" },
  { label: "CCR3 – Cherry Creek Res. Station 3", value: "81" },
];

const DEFAULTS = {
  start_date,
  end_date,
  locationid: 80,
};

const schema = z.object({
  start_date: z.string().default(DEFAULTS.start_date),
  end_date: z.string().default(DEFAULTS.end_date),
  locationid: z.coerce.number().default(DEFAULTS.locationid),
  controls: z.preprocess(
    (val) => val === "true" || val === true,
    z.boolean().default(false)
  ),
  height: z.preprocess(
    (val) => (typeof val === "string" ? parseInt(val, 10) : val),
    z.number().default(400)
  ),
});

export default function NutrientRatiosEmbed() {
  usePostHeight();
  const { params, setParams } = useQueryParams(schema);

  const getLocationLabel = () => {
    const location = LOCATION_OPTIONS.find(
      (l) => l.value === String(params.locationid)
    );
    return location ? location.label : "Location";
  };

  const FILTERS = [
    {
      type: "date",
      param: "start_date",
      label: "Start Date",
      default: params.start_date,
    },
    {
      type: "date",
      param: "end_date",
      label: "End Date",
      default: params.end_date,
    },
    {
      type: "select",
      param: "locationid",
      label: "Surface-water location",
      default: String(params.locationid),
      options: LOCATION_OPTIONS,
    },
  ];

  return (
    <>
      <main>
        {params.controls && (
          <Section>
            <Typography variant="h5" component="h2" gutterBottom>
              Filters
            </Typography>
            <FiltersForm config={FILTERS} onChange={setParams} />
          </Section>
        )}

        <Section>
          <Typography variant="h5" component="h2" gutterBottom>
            Nutrient Ratios at {getLocationLabel()}
          </Typography>
          <NutrientRatioChartContainer
            startDate={params.start_date}
            endDate={params.end_date}
            locationid={params.locationid}
            height={params.height}
          />
        </Section>
      </main>
    </>
  );
}
